import React from 'react'
import { Container, TableRow, TableBody, TableHeader, TableHeaderCell, Table, TableCell} from 'semantic-ui-react';

export function AsesorView(props) {
  const { Bioelite } = props;

  return (
    <div className='cotizacion-principal'>
      <Container className='cotizacion-principal_info'>
        <p>Cotización: <span className='cotizacion-principal_info-dxp'>{Bioelite.folio}</span></p>
        <p>Cardcode: <span className='cotizacion-principal_info-dxp'>{Bioelite.cardcode}</span></p>
        <p>Nombre del Cliente: <span className='cotizacion-principal_info-cliente'>{Bioelite.cliente}</span></p>
        <p>Especialidad: <span className='cotizacion-principal_info-especialidad'>{Bioelite.especialidad}</span></p>
        <p>Base: <span className='cotizacion-principal_info-base'>{Bioelite.base}</span></p>
        <p>Activos: <span className='cotizacion-principal_info-activos'>{Bioelite.activos}</span></p>
        <p>Padecimiento: <span className='cotizacion-principal_info-padecimiento'>{Bioelite.padecimiento}</span></p>
        {Bioelite.caducidad && <p>Caducidad en meses: <span className='cotizacion-principal_info-nombre'>{Bioelite.caducidad}</span></p>}
        {Bioelite.motivo && <p>Motivo de cancelación: <span className='cotizacion-principal_info-nombre'>{Bioelite.motivo}</span></p>}
        {Bioelite.observaciones && <p>Observaciones: <span className='cotizacion-principal_info-nombre'>{Bioelite.observaciones}</span></p>}
        <Container className='precio_unitario'>
                  <Table className='table-precio' celled>
                    <TableHeader>
                        <TableRow>
                        <TableHeaderCell>Presentaciones</TableHeaderCell>
                        <TableHeaderCell>Precio</TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    { Bioelite.base === 'Jarabe' ? (

                      <TableBody>
                        <TableRow>
                          <TableCell>30 ml</TableCell>
                          <TableCell>{Bioelite.precio30}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>50 ml</TableCell>
                          <TableCell>{Bioelite.precio50}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>120 ml</TableCell>
                          <TableCell>{Bioelite.precio120}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>240 ml</TableCell>
                          <TableCell>{Bioelite.precio240}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>1 L</TableCell>
                          <TableCell>{Bioelite.precio1L}</TableCell>
                        </TableRow>
                    </TableBody>
                      ) : 
                      <TableBody>
                      <TableRow>
                        <TableCell>30 Cápsulas</TableCell>
                        <TableCell>{Bioelite.precio30caps}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>60 Cápsulas</TableCell>
                        <TableCell>{Bioelite.precio60caps}</TableCell>
                      </TableRow>
                  </TableBody>
                    }
                  </Table>
                </Container>
      </Container>
    </div>

  )
}
